export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50 scroll-mt-16">
      <div className="max-w-2xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-4">
          联系我们 · 投稿合作
        </h2>
        <p className="text-sm text-foreground-500 mb-8">
          如果您有漫画资源推荐、合作建议或任何疑问，欢迎通过以下方式联系我们
        </p>
        <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/60">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-6">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-xl">
                <i className="ri-mail-line text-primary-500 text-xl"></i>
              </div>
              <div className="text-left">
                <div className="text-xs text-foreground-500">电子邮箱</div>
                <div className="text-sm font-medium text-foreground-900">contact@sakuracomic.com</div>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 flex items-center justify-center bg-accent-100 rounded-xl">
                <i className="ri-wechat-line text-accent-600 text-xl"></i>
              </div>
              <div className="text-left">
                <div className="text-xs text-foreground-500">微信公众号</div>
                <div className="text-sm font-medium text-foreground-900">樱花漫画网</div>
              </div>
            </div>
          </div>
          <p className="text-sm text-foreground-500 leading-relaxed">
            我们期待与更多优秀的漫画创作者和版权方合作，共同为广大漫画爱好者提供更丰富的<strong>全集漫画</strong>内容。投稿与合作咨询将在24小时内回复。
          </p>
        </div>
      </div>
    </section>
  );
}